
const _ = {
    initialized: false
};

export function initializeIdentity(userAccountIdentity, securityData) {

    if (_.initialized) {
      return;
    }

    Object.assign(_, {
        userAccount: userAccountIdentity, // { id, fullName, iconId }
        userAccountId: userAccountIdentity.id,
        companyId: securityData.currentCompanyId,
        companyCode: securityData.currentCompanyCode,
        companyName: securityData.currentCompanyName,
        companyCountryCode: securityData.currentCompanyCountryCode,
        isImpersonating: securityData.isImpersonating,
        isMomentTeamUser: securityData.isMomentTeamUser,
        isInMomentContext: securityData.isInMomentContext,
        isInMainCompanyContext: securityData.isInMainCompanyContext,
        isSystemAdministrator: securityData.isSystemAdministrator,
        initialized: true
    });
}

export function updatePermissions(permissions) {
    if (_.initialized && _.userAccount) {
        _.userAccount = { ..._.userAccount, permissions };
        return true;
    }
    return false;
}

class IdentityApi {

    get initialized() {
      return _.initialized;
    }

    get userAccountId() {
        this.validateGet();
        return _.userAccountId;
    }

    set userAccountId(_value) {
        this.validateSet();
    }

    get userAccount() {
        this.validateGet();
        return _.userAccount;
    }

    set userAccount(_value) {
        this.validateSet();
    }

    get companyCode() {
        this.validateGet();
        return _.companyCode;
    }

    set companyCode(_value) {
        this.validateSet();
    }

    get companyName() {
      this.validateGet();
      return _.companyName;
    }

    set companyName(_value) {
        this.validateSet();
    }

    get companyCountryCode() {
        this.validateGet();
        return _.companyCountryCode;
    }

    set companyCountryCode(_value) {
        this.validateSet();
    }

    get isImpersonating() {
      this.validateGet();
      return _.isImpersonating;
  }

    isMomentTeamUser() {
      return _.isMomentTeamUser;
    }

    isInMomentContext() {
      return _.isInMomentContext;
    }

    /** @deprecated misleading name for the Moment-context check; use isInMomentContext. */
    isInCompanyContext() {
      return _.isInMomentContext;
    }

    /** @deprecated misleading name for the Moment-context check; use isInMomentContext. */
    isMomentCompanyCode() {
      return _.isInMomentContext;
    }

    isInMainCompanyContext() {
      return _.isInMainCompanyContext;
    }

    isSystemAdministrator() {
      return _.isSystemAdministrator;
    }

    set isImpersonating(_value) {
        this.validateSet();
    }

    validateGet() {
        if (!_.initialized) {
            throw new Error('Identity isn\'t initialized');
        }
    }

    validateSet() {
        throw new Error('Property is read-only');
    }
}


const Identity = new IdentityApi();


export default Identity;
